import React, { useState } from "react";
import { Link } from "react-router-dom";

//import Components
import LanguageDropdown from "../components/Common/LanguageDropdown";

import { AppLogo, ProfileDropdown } from "../components/Common";
import { FullScreenDropdown } from "../components/Common/FullScreenDropdown";
import LightDark from "../components/Common/LightDark";
import { useSelector } from "react-redux";
import { RoleEnum } from "../enums";
import { useTranslation } from "react-i18next";
import { AccountState } from "../store/slices/accountSlice";

export const Header = ({
  onChangeLayoutMode,
  layoutModeType,
  headerClass,
}: any) => {
  const [search, setSearch] = useState(false);
  const toggleSearch = () => {
    setSearch(!search);
  };

  const { t } = useTranslation();
  const toggleMenuBtn = () => {
    var windowSize = document.documentElement.clientWidth;

    if (windowSize > 767)
      document.querySelector(".hamburger-icon")?.classList.toggle("open");

    //For collapse horizontal menu
    if (document.documentElement.getAttribute("data-layout") === "horizontal") {
      document.body.classList.contains("menu")
        ? document.body.classList.remove("menu")
        : document.body.classList.add("menu");
    }

    //For collapse vertical menu
    if (document.documentElement.getAttribute("data-layout") === "vertical") {
      if (windowSize < 1025 && windowSize > 767) {
        document.body.classList.remove("vertical-sidebar-enable");
        document.documentElement.getAttribute("data-sidebar-size") === "sm"
          ? document.documentElement.setAttribute("data-sidebar-size", "")
          : document.documentElement.setAttribute("data-sidebar-size", "sm");
      } else if (windowSize > 1025) {
        document.body.classList.remove("vertical-sidebar-enable");
        document.documentElement.getAttribute("data-sidebar-size") === "lg"
          ? document.documentElement.setAttribute("data-sidebar-size", "sm")
          : document.documentElement.setAttribute("data-sidebar-size", "lg");
      } else if (windowSize <= 767) {
        document.body.classList.add("vertical-sidebar-enable");
        document.documentElement.setAttribute("data-sidebar-size", "lg");
      }
    }

    //Two column menu
    if (document.documentElement.getAttribute("data-layout") === "twocolumn") {
      document.body.classList.contains("twocolumn-panel")
        ? document.body.classList.remove("twocolumn-panel")
        : document.body.classList.add("twocolumn-panel");
    }
  };

  const profile = useSelector(
    (state: { account: AccountState }) => state.account.userProfile,
  );

  return (
    <React.Fragment>
      <header id="page-topbar" className={headerClass}>
        <div className="layout-width">
          <div className="navbar-header">
            <div className="d-flex">
              <div className="navbar-brand-box horizontal-logo">
                <Link to="/" className="logo logo-dark">
                  <span className="logo-sm">
                    <AppLogo width={50} />
                  </span>
                  <span className="logo-lg">
                    <AppLogo width={80} />
                  </span>
                </Link>

                <Link to="/" className="logo logo-light">
                  <span className="logo-sm">
                    <AppLogo width={60} />
                  </span>
                  <span className="logo-lg">
                    <AppLogo width={60} />
                  </span>
                </Link>
              </div>

              <button
                onClick={toggleMenuBtn}
                type="button"
                className="btn btn-sm px-3 fs-16 header-item vertical-menu-btn topnav-hamburger"
                id="topnav-hamburger-icon"
              >
                <span className="hamburger-icon">
                  <span></span>
                  <span></span>
                  <span></span>
                </span>
              </button>

              {profile &&
                profile.role.key === RoleEnum.TEACHER_ADMIN &&
                profile.deadline && (
                  <label className="text-white  align-self-center d-none d-md-block  d-flex mt-3 px-4">
                    <label className="badge bg-danger text-white  fs-6">
                      {t("deadline")} :{" "}
                      {new Date(profile.deadline).toLocaleDateString()}
                    </label>
                  </label>
                )}
            </div>

            <div className="d-flex align-items-center">
              <LanguageDropdown />

              <FullScreenDropdown />

              <LightDark
                layoutMode={layoutModeType}
                onChangeLayoutMode={onChangeLayoutMode}
              />

              <ProfileDropdown />
            </div>
          </div>
        </div>
      </header>
    </React.Fragment>
  );
};
